import React from 'react'
import styles from '../styles/utils.module.css'
import Image from '../images/profile.png'

export default function Icon() {
  return (
    <>
      <img src={Image} alt="icon"
        className={styles.icon}
      />
    </>
  )
}
